// Types
import { MetaTag } from "interfaces/shared/metaTag";

export const FORMAZIONE_PAGE = "/formazione";
export const CALENDARIO_CORSI_MASTER_PAGE = "/calendario-corsi-e-master";
export const VIDEO_THANKYOU_PAGE = "/video/thankyou";
export const PRODUCT_ELEARNING = "elearning";
export const PRODUCT_BUNDLE_ELEARNING = "Bundle";
export const PRODUCT_PAGE_TYPES = [PRODUCT_ELEARNING, "corso", "corsoonline", "master", "percorsoadvanced", "percorso", "forum", "convegni"];
export const ENVIRONMENT = [
    process.env.NEXT_PUBLIC_GPO_ENVIRONMENT,
    process.env.NEXT_PUBLIC_SHOPWKI_GPO_ENVIRONMENT
]
export const CACHE_TIME = 120; // time of caching initial APIs expressed in seconds
export const PROFILO_UTENTE_TAB_URL = "/user/iscritto/AreaPersonale.aspx?tab=profilo-utente";
export const CORSI_TAB_URL = "/user/iscritto/AreaPersonale.aspx?tab=corsi";
export const ATTESTATI_TAB_URL = "/user/iscritto/AreaPersonale.aspx?tab=attestati";
export const GENERIC_GTM_ID = "GTM-53VFLLN";
export const TDM_META_TAGS: MetaTag[] = [{ name: 'tdm-reservation', content: '1'},{ name: 'tdm-policy', content: 'https://formazione.ipsoa.it/policies/policy.json'}];
